export const SET_TABLE_DATA = 'SET_TABLE_DATA';
export const SET_ORDERING = 'SET_ORDERING';
export const SET_META_VALUE = 'SET_META_VALUE';
export const SET_ORDERING_STATUS = 'SET_ORDERING_STATUS';
export const ERROR = 'ERROR';
export const IS_LOADING = 'IS_LOADING';
export const SET_GLYICON = 'SET_GLYICON';
export const UPDATE_METADATA = 'UPDATE_METADATA';

//store reducer
export const GET_MODULES = 'GET_MODULES';
export const GET_ORGANIZATIONS = 'GET_ORGANIZATIONS';
export const GET_SECTIONS = 'GET_SECTIONS';
export const GET_CATEGORIES = 'GET_CATEGORIES';
export const POST_MODULE = 'POST_MODULE';
export const UPDATE_REMINDER = 'UPDATE_REMINDER';
export const KEY_DATA_FLAG = 'KEY_DATA_FLAG';
export const CDS_FLAG = 'CDS_FLAG';
export const BFCP_HE_LOCK_DESCRIPTION = 'BFCP_HE_LOCK_DESCRIPTION';
export const SEL_SEARCH_VAL = 'SEL_SEARCH_VAL';
export const DYAMIC_DSP_MAJ_SELECT = 'DYAMIC_DSP_MAJ_SELECT';
export const SELECT_ALL_COLUMNS = 'SELECT_ALL_COLUMNS';
export const UPDATE_SUB_COL_HEADERS = 'UPDATE_SUB_COL_HEADERS';
export const UPDATE_SEARCH_TERM = 'UPDATE_SEARCH_TERM';
export const UPDATE_FEATURE_FLAG = 'UPDATE_FEATURE_FLAG';

//category reducers
export const GET_CATEGORY_DATA = 'GET_CATEGORY_DATA';
export const GET_PRIORITY_STATUS = 'GET_PRIORITY_STATUS';
export const SET_PUBLISH_CAT_ID = 'SET_PUBLISH_CAT_ID';
export const SET_PUBLISH_ERROR = 'SET_PUBLISH_ERROR';
export const GET_CDS_STATUS = 'GET_CDS_STATUS';
//role reducers
export const GET_NEW_ROLES = 'GET_NEW_ROLES';
export const GET_INSTITUTION_COUNT = 'GET_INSTITUTION_COUNT';
export const GET_OID = 'GET_OID';
export const GET_ORGID_ROLES = 'GET_ORGID_ROLES';

export const GET_ITEMS_SAVED = 'GET_ITEMS_SAVED';
export const GET_ITEMS_BEING_SAVED = 'GET_ITEMS_BEING_SAVED';
export const GET_UNSAVED_HEADERS = 'GET_UNSAVED_HEADERS';

//modulepages
export const SET_MODULE_DATA = 'SET_MODULE_DATA';
export const SET_LOADING_STATUS = 'SET_LOADING_STATUS';
export const SET_ALERT_MESSAGE = 'SET_ALERT_MESSAGE';
export const SET_MODULE_SUM_STATUS = 'SET_MODULE_SUM_STATUS';
export const SET_READY_FOR_SUBMIT = 'SET_READY_FOR_SUBMIT';
export const UPDATE_UNSAVED_MODULE = 'UPDATE_UNSAVED_MODULE';
export const SET_TRIGGER_MODULE_ID='SET_TRIGGER_MODULE_ID';
export const SET_SAVE_STATUS= 'SET_SAVE_STATUS';


